import { ClassPlan, ClassSession, ClassTab, UpgradeOption } from 'modules/jogador/classes/types';

export const CLASS_TABS: { value: ClassTab; label: string }[] = [
  { value: 'meu-plano', label: 'Meu plano' },
  { value: 'pacotes', label: 'Pacotes' },
  { value: 'avulsas', label: 'Avulsas' },
];

export const CURRENT_PLAN: ClassPlan = {
  name: 'Turma B · 2x semana',
  scheduleLabel: 'Ter e qui · 07:00 · Prof. Camila',
  status: 'Ativa',
  nextBillingLabel: '05/10',
  nextBillingAmount: 250,
  guaranteedUntilLabel: '04/10',
};

export const UPCOMING_SESSIONS: ClassSession[] = [
  {
    id: 'ter-17',
    day: 'TER',
    dateLabel: '17',
    timeLabel: '07:00',
    court: 'Areia 2',
    className: 'Turma B',
    attendanceLabel: '5/6 alunos',
  },
  {
    id: 'qui-19',
    day: 'QUI',
    dateLabel: '19',
    timeLabel: '07:00',
    court: 'Areia 2',
    className: 'Turma B',
    attendanceLabel: '4/6 alunos',
  },
];

export const UPGRADE_OPTIONS: UpgradeOption[] = [
  { id: '3x-semana', title: '3x semana', meta: 'seg, qua, sex · turma fixa', price: 340, priceSuffix: '/mês' },
  { id: '10-aulas', title: 'Pacote 10 aulas avulsas', meta: 'direito de uso válido por 90 dias', price: 450, priceSuffix: 'à vista' },
];
